export default function logout() {
    return {
        
        logoutUser() {
            fetch('/api/login/SignOut', { "method": "GET" })
                .then(response => {
                    if (response.ok) {
                        return response.json()
                    }
                }).then(response => {
                    if (response != undefined && response.isSuccess) {
                        window.location.href='/'
                    }

                });
        },
        init() {
            this.logoutUser();
        },
    };
}
